export default __webpack_public_path__ + "static/media/bolster.038f393f.webp";